import { render, staticRenderFns } from "./Ponto.vue?vue&type=template&id=ce2ef32a&scoped=true&"
import script from "./Ponto.vue?vue&type=script&lang=js&"
export * from "./Ponto.vue?vue&type=script&lang=js&"
import style0 from "./Ponto.vue?vue&type=style&index=0&id=ce2ef32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2ef32a",
  null
  
)

export default component.exports